import React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import _ from 'lodash'

import Divider from '@material-ui/core/Divider'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'

import { openFile } from './actions'
import { openFileToLine } from './Editor'
import MenuGroup from './MenuGroup'

import { getMenuItems } from './selectors'
import {
  IMaxThreads,
  IState,
  ITemperature,
  TOMBSTONE_KEYWORDS,
} from './types'

import {
  AUDIO_NETWORK_LATENCY_KEYWORDS,
  BLOCKED_THREAD_KEYWORDS,
  BOOT_LOOP_KEYWORDS,
  CRITICAL_KEYWORDS,
  HEALTH_CHECK_KEYWORDS,
  LOGCAT_KEYWORDS,
  MONITORING_KEYWORDS,
  NAVIGATIONAL_KEYWORDS,
  SUSPICIOUS_KEYWORDS,
} from './types'

export interface IStateProps {
  buildNumber: string
  hardwareVariant: string
  maxThreads: IMaxThreads
  solsticeVersion: string
  storage: string
  temperature: ITemperature
}

interface IDispatchProps {
  openFile: (id: number) => void
}

type IAllProps = IStateProps & IDispatchProps

export interface IMenuItemsState {
  logcatOpen: boolean
}
class MenuItems extends React.Component<IAllProps, IMenuItemsState> {

  protected MENU_GROUPS = [
    {
      internalName: 'tombstones',
      keywords: TOMBSTONE_KEYWORDS,
      title: 'Tombstones',
    },
    {
      internalName: 'logcat',
      keywords: LOGCAT_KEYWORDS,
      title: 'Logcat files',
    },
    {
      internalName: 'blocked',
      keywords: BLOCKED_THREAD_KEYWORDS,
      title: 'Blocked threads',
    },
    {
      internalName: 'bootloop',
      keywords: BOOT_LOOP_KEYWORDS,
      title: 'Possible boot loops',
    },
    {
      internalName: 'critical',
      keywords: CRITICAL_KEYWORDS,
      title: 'Critical',
    },
    {
      internalName: 'healthChecks',
      keywords: HEALTH_CHECK_KEYWORDS,
      title: 'Health checks',
    },
    {
      internalName: 'monitoring',
      keywords: MONITORING_KEYWORDS,
      title: 'Monitoring',
    },
    {
      internalName: 'navigational',
      keywords: NAVIGATIONAL_KEYWORDS,
      title: 'Navigational',
    },
    {
      internalName: 'audio',
      keywords: AUDIO_NETWORK_LATENCY_KEYWORDS,
      title: 'Audio Latency',
    },
    {
      internalName: 'suspicious',
      keywords: SUSPICIOUS_KEYWORDS,
      title: 'Suspicious',
    },
  ]

  public render() {

    const {
      buildNumber,
      hardwareVariant,
      maxThreads,
      solsticeVersion,
      storage,
      temperature,
    } = this.props

    return (
      <List>
        <ListItem dense={true}>
          <ListItemText primary={'Hardware Variant'} secondary={hardwareVariant}/>
        </ListItem>
        <ListItem dense={true}>
          <ListItemText primary={'Latest Solstice Version'} secondary={solsticeVersion}/>
        </ListItem>
        <ListItem dense={true}>
          <ListItemText primary={'Latest Build Number'} secondary={buildNumber}/>
        </ListItem>
        <ListItem dense={true}>
          <ListItemText primary={'Storage'} secondary={storage}/>
        </ListItem>
        {
          temperature.max > 0 &&
          <ListItem button={true} component={'a'} dense={true} onClick={() => openFileToLine(temperature)}>
            <ListItemText primary={'Max temp'} secondary={`${temperature.max}°C`}/>
          </ListItem>
        }
        {
          maxThreads.max > 0 &&
          <ListItem button={true} component={'a'} dense={true} onClick={() => openFileToLine(maxThreads)}>
            <ListItemText primary={'Max thread count'} secondary={maxThreads.max}/>
          </ListItem>
        }
        <Divider />

        {this.MENU_GROUPS.map(group => (
          <MenuGroup
            key={group.internalName}
            keywords={group.keywords}
            openFileToLine={openFileToLine}
            title={group.title}
          />)
        )}
      </List>
    )
  }
}

const mapStateToProps = (state: IState): IStateProps => ({
  ...getMenuItems(state),
})
const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
  openFile: (id: number) => dispatch(openFile(id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(MenuItems)



// WEBPACK FOOTER //
// ./src/MenuItems.tsx